export const HELI_TYPES = [
    { text: 'H160_B', value: 'H160_B' },
    { text: 'BK117_D3 & BK117_D3m', value: 'BK117_D3' },
    { text: 'AS350_B3', value: 'AS350_B3' },
    { text: 'EC130_T2', value: 'EC130_T2' },
    { text: 'EC225_LP', value: 'EC225_LP' },
    { text: 'EC175_B', value: 'EC175_B' }, 
    { text: 'EC135_T4', value: 'EC135_T4' }
]
